import React, { useEffect, useState } from 'react'
import { useBrandsQuery, useChangeServiceBrandStatusMutation, useCreateBrandMutation, useDeleteServiceBrandMutation, useServicesQuery, useSingleBrandQuery, useUpdateBrandMutation } from '../../../Store/Apis/servicesApi'
import Loader from '../../../Components/Loader/Loader'
import Error from '../../../Components/Error/Error'
import { SearchOutlined, DownOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import AddEditBrand from '../../../Components/AddEditBrand/AddEditBrand';
import toast from 'react-hot-toast';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { isDropdownPermission } from '../../../Hooks/permissionsMiddleware';
import { useOutletsQuery } from '../../../Store/Apis/outletApi';
const Brands = () => {
  const user = useSelector((state) => state.auth.user)
  const [sortFilter, setSortFilter] = useState({
    keyword: '',
    outletID: ''
  });
  const outletList = useOutletsQuery()
  // const serviceList = useServicesQuery()
  const brandsApi = useBrandsQuery(sortFilter)
  const [viewEditItem, setViewEditItem] = useState(null);  

  // ADD BRAND
  const [createBrand, createBrandResponse] = useCreateBrandMutation();
  const [addBrandModalShow, setAddBrandModalShow] = useState(false);

  const AddBrand = () => {
    const handleCreateBrandSubmit = (formData) => {
      console.log('Brand Submitted:', formData);
      const brandBody = {
        brandName: formData.brandName,
        categoryId: formData.category,
        image: formData.logo,
        isActive: 1
      };
      createBrand(brandBody)
        .then((res) => {
          console.log(res);
          if (res?.data?.status === 200) {
            setAddBrandModalShow(false);
            toast.success(res?.data?.message, { duration: 7000 });
          } else {
            toast.error(res?.data?.message, { duration: 7000 });
          }
        })
        .catch((err) => {
          toast.error("An error occurred. Please try again.", { duration: 7000 });
        });
    };

    return (
      <Modal show={addBrandModalShow} onHide={() => setAddBrandModalShow(false)} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Add New Brand</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddEditBrand onSubmit={handleCreateBrandSubmit} />
        </Modal.Body>
      </Modal>
    );
  };

  // EDIT BRAND
  const [updateBrand, updateBrandResponse] = useUpdateBrandMutation();
  const [updateBrandId, setUpdateBrandId] = useState(null);
  const [updateBrandModalShow, setupdateBrandModalShow] = useState(false);
  const singleBrand = useSingleBrandQuery(
    {
      keyID: updateBrandId
    },
    {skip: !updateBrandId}
  )

  const UpdateBrand = () => {
    console.log(singleBrand)
    const handleCreateBrandSubmit = (formData) => {
      console.log('Brand Submitted:', formData);
      const brandBody = {
        id: updateBrandId,
        brandName: formData.brandName,
        categoryId: formData.category,
        image: formData.logo,
        isActive: 1
      };

      updateBrand(brandBody)
        .then((res) => {
          console.log(res);
          if (res?.data?.status === 200) {
            setupdateBrandModalShow(false);
            toast.success(res?.data?.message, { duration: 7000 });
          } else {
            toast.error(res?.data?.message, { duration: 7000 });
          }
        })
        .catch((err) => {
          toast.error("An error occurred. Please try again.", { duration: 7000 });
        });
    };

    return (
      <Modal show={updateBrandModalShow} onHide={() => setupdateBrandModalShow(false)} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Brand</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddEditBrand 
            onSubmit={handleCreateBrandSubmit}
            data={{
              category: singleBrand?.data?.data[0].categoryID,
              brandName: singleBrand?.data?.data[0].brandName,
              logo: singleBrand?.data?.data[0].brandImage
            }} />
        </Modal.Body>
      </Modal>
    );
  };


  // STAUS CHANGE
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [changeStatus] = useChangeServiceBrandStatusMutation()
  const handleChangeStatus = () => {
      changeStatus(selectedStatus).then((res)=>{
        console.log(res)
        setSelectedStatus(null)
      })
  }

  // DELETE
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [deleteCategory] = useDeleteServiceBrandMutation()
  const handleDelete = () => {
      deleteCategory(selectedRecord).then((res)=>{
        console.log(res)
        setSelectedRecord(null)
      })
  }


  useEffect(() => {
    if (user.role !== 'superAdmin') {
      setSortFilter({
        ...sortFilter,
        outletID: user.outletID
      });
    }    
  }, []);


  const columns = [
    {
      title: 'Brand',
      dataIndex: 'brandName',
      key: 'brandName',
      sorter: (a, b) => a.brandName.localeCompare(b.brandName),
      filter: (value, record) => record.brandName.toLowerCase().includes(value.toLowerCase()),
      filterIcon: <SearchOutlined />,
      onFilter: (value, record) => record.brandName.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Category',
      dataIndex: 'categoryName',
      key: 'categoryName',
      sorter: (a, b) => a.categoryName.localeCompare(b.serviceName),
      filter: (value, record) => record.categoryName.toLowerCase().includes(value.toLowerCase()),
      filterIcon: <SearchOutlined />,
      onFilter: (value, record) => record.categoryName.toLowerCase().includes(value.toLowerCase()),
      render: (i, action) => (
        <>
          <p className='mb-1 text-sm'>{action.categoryName}</p>
        </>
      )
    },
    {
      title: 'Brand Image',
      dataIndex: 'brandImage',
      key: 'brandImage',
      render: (i, action) => (
        <>
          <img src={action.brandImage} alt="" height={50} />
        </>
      )
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (i, action) => (
        <button 
          type='button' 
          className={`btn badge badge-xs ${action.isActive == 1 ? 'badge-success': 'badge-danger'} fw-600 text-xs mb-0`} 
          onClick={() => setSelectedStatus({
              keyID: action.brandID,
              isActive: action.isActive == 1 ? 0 : 1
          })}
        >
            {action.isActive == 1 ? 'Active': 'Deactivated'}
        </button>
      )
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      render: (i, action) => (
        <>
          <button type='button' className="btn badge badge-xs badge-warning fw-600 text-xs mb-0" onClick={() => (setUpdateBrandId(action.brandID), setupdateBrandModalShow(true))}>
            View & Edit
          </button>
          <button 
            type='button'
            className="btn ms-2 badge badge-xs badge-danger text-xs fw-600 mb-0"
            onClick={()=>setSelectedRecord(action.brandID)}
          >
            Delete
          </button>
        </>
      ),
    }
  ]

  
  return (
    <div>
      <div className="row align-items-center justify-content-between mb-3">
        <div className="col">
          <h5 className="fw-500 text-white">Brand</h5>
        </div>
        <div className="col-auto">
          <button type='button' className="btn btn-icon btn-3 btn-white text-primary mb-0" onClick={() => setAddBrandModalShow(true)}>
            <i className="fa fa-plus me-2"></i> Add Brand
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card mb-4">
            <div className="card-header p-4">
              <div className="row gx-3">
                <div className="col-md-9">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Brand Name"
                    value={sortFilter?.keyword || ""}
                    onChange={(e) => setSortFilter({...sortFilter, keyword: e.target.value})}
                  />
                </div>
                <div className="col-md-3">
                  <select
                    className="form-select"
                    onChange={(e) => setSortFilter({ ...sortFilter, outletID: e.target.value })}
                    value={sortFilter?.outletID}
                    disabled={(outletList.isSuccess === true && !isDropdownPermission(user.role_Id))}
                  >
                    <option value="">
                      All Category
                    </option>
                    {
                      outletList?.data?.data.map((elem, i) => (
                        <option value={elem.outletId} key={i}>{elem.outletName}</option>
                      ))
                    }
                  </select>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              {brandsApi.isError && <Error/>}
              {brandsApi.isLoading && <Loader height="500px"/>}
              {
                brandsApi.isSuccess && (
                  <>
                    <Table 
                      columns={columns} 
                      dataSource={brandsApi?.data?.data}
                    />
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>

      <AddBrand/>
      <UpdateBrand/>

      {/* STATUS CHANGE MODAL */}
      <Modal 
          show={selectedStatus} 
          onHide={() => setSelectedStatus(null)} 
          size="sm" 
          centered
      >
          <Modal.Body className='text-center p-4'>
              <h5>Are you sure you want to change status?</h5>
              <div className="buttons d-flex gap-3 justify-content-center">
                  <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={()=>(setSelectedStatus(null))}>Cancel</button>
                  <button className='btn btn-primary btn-sm mb-0' onClick={handleChangeStatus}>Confirm</button>
              </div>
          </Modal.Body>
      </Modal>

      {/* DELETE MODAL */}
      <Modal  
          show={selectedRecord} 
          onHide={() => setSelectedRecord(null)} 
          size="sm" 
          centered
      >
          <Modal.Body className='text-center p-4'>
              <h5>Are you sure you want to delete the brand?</h5>
              <div className="buttons d-flex gap-3 justify-content-center">
                  <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={()=>(setSelectedRecord(null))}>Cancel</button>
                  <button className='btn btn-primary btn-sm mb-0' onClick={handleDelete}>Confirm</button>
              </div>
          </Modal.Body>
      </Modal>


    </div>
  )
}

export default Brands